export enum Views {
  PORTFOLIO = "portfolio",
  LINKS = "links"
}